import { Box, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";

// Composant qui affiche une liste de cartes statistiques
const StatsCards = ({ cards }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexWrap: "wrap",
        scrollSnapType: isMobile ? "x mandatory" : "none",
        pb: 2,
        width: "100%",
        boxSizing: "border-box",
        justifyContent: isMobile ? "flex-start" : "center"
      }}
    >
      {cards.map((card, index) => (
        <Box
          key={index}
          sx={{
            minWidth: isMobile ? 80 : "auto",
            maxWidth: isMobile ? "100vw" : "auto",
            flexShrink: 0,
            scrollSnapAlign: "start"
          }}
        >
          <Paper elevation={3} sx={{
            p: 2,
            minHeight: isMobile ? 40 : 60,
            minWidth: isMobile ? 40 : 60,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            bgcolor: "#fafafa",
            flex: "1 1 200px" 
          }}>
            <Typography 
              sx={{
                fontSize: isMobile ? "0.65rem" : "0.9rem",
                color: "text.secondary",
                lineHeight: 1.2,
                whiteSpace: "normal",
                wordBreak: "break-word"
              }}
            >
              {card.icon} {card.label}
            </Typography>
            <Typography 
              sx={{
                fontSize: isMobile ? "0.8rem" : "1.2rem",
                fontWeight: "bold",
                lineHeight: 1.3
              }}
            >
              {card.value}
            </Typography>
          </Paper>
        </Box>
      ))}
    </Box>
  );
};

export default StatsCards;
